import { Injectable } from '@angular/core'
import { IDataConverter } from '@adex/shared/models/data-converter'
import { INotificationChannelOneDto, INotificationDto, NotificationParamsDto } from '@adex/shared/models/dto/notification.dto'
import { getEmailNon, getSlNon, getTgNon, NotificationType } from '@adex/shared/models/inside-models/notification'
import { on, when } from '@adex/shared/utils/when'
import { ChannelType } from '@adex/shared/models/inside-models/notification-type'
import { isEmpty } from '@adex/shared/utils/data'


@Injectable({
  providedIn: 'any'
})
export class NotificationConverter implements IDataConverter<INotificationChannelOneDto, NotificationType> {

  public toInside({ channel: data }: INotificationChannelOneDto): NotificationType {
    const { id, isDefault, lastNotification, name, params, type } = data
    return {
      id, isDefault, lastNotification,
      channelName: name,
      channelType: type as any,
      ...params
    } as NotificationType
  }

  public toOutside(data: NotificationType): INotificationChannelOneDto {
    const { channelName, channelType, isDefault, id } = data
    const channel: INotificationDto = {
      name: channelName,
      type: channelType as any,
      isDefault,
      id: isEmpty(id) ? undefined : +id,
      params: when<ChannelType, NotificationParamsDto>(
        channelType,
        on(ChannelType.email, () => ({ email: getEmailNon(data).email })),
        on(ChannelType.telegram, () => ({ apiToken: getTgNon(data).apiToken, chatId: getTgNon(data).chatId })),
        on(ChannelType.slack, () => ({ channel: getSlNon(data).channel, token: getSlNon(data).token }))
      )
    }
    return { channel }
  }

}
